import * as types from "./mutations-type";
export default{
    [types.SET_USER](state,payload){
        state.user = payload
    },
    [types.SET_TOKEN](state,payload){
        state.token = payload
    },
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_CONFIGURACAOGERAL](state,payload){
        state.configuracaogeral = payload
    },
    [types.SET_EDITAR](state,payload){
        state.editar = payload
    },
    [types.SET_LISTANOTIFICACAO](state,payload){
        state.listanotificao = payload
    },
}